import {
  apiRegister
} from '../../common/api';
import { isNumber } from '../../common/utils';
import { ERR_REQ_GAME_ID } from '../../common/const';

/*
协议Id 
878
项目 
模块 
方式 
https 
命令（路径） 
/award/match/adduser/
说明
预约报名和报名
请求参数
参数名称	参数类型	说明
cId	int	比赛配置id

*/

const matchSign = apiRegister('match-sign',  {
  protoId: 878,
  path: '/award/match/adduser/',
  checkQuery(Q) {
    if (!isNumber(Q.cId)) {
      return ERR_REQ_GAME_ID // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    return R
  }
})

export const matchSignLoad = matchSign.send
